export const PRIVACY_INTRO = [
    'Политика нужна для защиты личной информации, которую Пользователь передает Администратору. Администратор может получать такие данные при использовании Пользователем Сайта bypass-vpn.ru.',
    {
        parts: [
            { type: 'text', value: 'Термины в Политике применяются в значении, установленном в ' },
            { type: 'link', to: '/terms', value: 'Правилах' },
            { type: 'text', value: '.' },
        ],
    },
];

export const PRIVACY_SECTIONS = [
    {
        id: 'operator',
        title: 'Кто оператор?',
        paragraphs: ['Администратор является оператором персональных данных.'],
    },
    {
        id: 'about',
        title: 'О чем эта Политика?',
        paragraphs: [
            'Политика определяет порядок обработки персональных данных, а также меры по обеспечению их безопасности и конфиденциальности.',
        ],
    },
    {
        id: 'what-is-pd',
        title: 'Что такое персональные данные?',
        paragraphs: [
            'Персональные данные — это любая информация, которая относится к конкретному физическому лицу.',
            'Администратор собирает только те данные, которые необходимы для обеспечения полной функциональности его цифровых продуктов.',
        ],
    },
    {
        id: 'whose-data',
        title: 'Чьи данные обрабатываются?',
        paragraphs: ['Администратор обрабатывает персональные данные Пользователей и посетителей Сайта.'],
    },
    {
        id: 'rights',
        title: 'Какие права есть у Пользователя?',
        rights: [
            {
                title: 'Право на доступ',
                text: 'Пользователь может запросить копию/выписку данных или экспортировать их самостоятельно.',
            },
            {
                title: 'Право на исправление',
                text: 'Пользователь может попросить Администратора скорректировать неточные, неполные или устаревшие данные.',
            },
            {
                title: 'Право на блокирование и удаление',
                text: 'Пользователь может запросить блокировку или удаление данных. Администратор удалит их в течение 30 дней после получения запроса.',
            },
            {
                title: 'Право на отзыв',
                text: 'Пользователь может отозвать свое согласие на обработку данных. В таком случае некоторые функции Сайта могут стать недоступны.',
            },
            {
                title: 'Право на деактивацию cookies',
                text: 'Пользователь может удалить или заблокировать cookie-файлы, установленные Сайтом, в настройках своего браузера.',
            },
            {
                title: 'Право на получение информации',
                text: 'Пользователь может получить любую информацию об обработке его данных.',
            },
            {
                title: 'Право на обжалование',
                text: 'Пользователь может обжаловать действия или бездействие Администратора в территориальном органе Роскомнадзора.',
            },
        ],
    },
    {
        id: 'processing',
        title: 'Какие данные, с какой целью, как долго и на каком основании обрабатываются?',
        processingItems: [
            {
                goal: 'передача Ключа доступа',
                fields: [
                    { label: 'Персональные данные', value: 'платежные данные' },
                    { label: 'Категория', value: 'иные' },
                    { label: 'Способ обработки', value: 'автоматизированный' },
                    {
                        label: 'Срок обработки',
                        value: 'в течение срока доступа к личному кабинету или до отзыва согласия на обработку',
                    },
                    { label: 'Правовое основание', value: 'исполнение договора — акцепт Правил' },
                ],
            },
            {
                goal: 'обратная связь с Пользователями',
                fields: [
                    {
                        label: 'Персональные данные',
                        value: 'адрес электронной почты, номер телефона, никнейм и юзернейм в мессенджерах, содержание обращения',
                    },
                    { label: 'Категория', value: 'общедоступные, иные' },
                    { label: 'Способ обработки', value: 'автоматизированный' },
                    {
                        label: 'Срок обработки',
                        value: 'в течение срока коммуникации по вопросу Пользователя или до отзыва согласия на обработку',
                    },
                    { label: 'Правовое основание', value: 'согласие на обработку персональных данных' },
                ],
            },
            {
                goal: 'обеспечение корректной работы Сайта',
                fields: [
                    { label: 'Персональные данные', value: 'cookie-файлы' },
                    { label: 'Категория', value: 'иные' },
                    { label: 'Способ обработки', value: 'автоматизированный' },
                    {
                        label: 'Срок обработки',
                        value: 'до истечения срока жизни cookies или их деактивации',
                    },
                    {
                        label: 'Правовое основание',
                        value: 'согласие на обработку cookie-файлов, которое выражается путем совершения конклюдентных действий — продолжение использования Сайта',
                    },
                ],
            },
        ],
    },
    {
        id: 'how-processed',
        title: 'Как обрабатываются данные?',
        paragraphs: [
            'Для достижения указанных целей Администратор будет выполнять следующие действия с данными: сбор, запись, систематизация, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передача (доступ, предоставление), обезличивание, блокирование, удаление, уничтожение.',
        ],
    },
    {
        id: 'destruction',
        title: 'Как уничтожаются данные?',
        paragraphs: [
            'Порядок уничтожения персональных данных: удаление в информационных системах Администратора с помощью встроенных программных средств.',
        ],
    },
    {
        id: 'security',
        title: 'Как обеспечивается безопасность данных?',
        paragraphs: [
            'Администратор защищает персональные данные от разглашения, полной или частичной утраты и несанкционированного доступа третьих лиц.',
            'Для этого Администратор принимает все необходимые технические и организационные меры по обеспечению безопасности и конфиденциальности согласно ст. 18, 18.1, 19 ФЗ-152.',
        ],
        bullets: [
            'выполняет шифрование данных',
            'использует антивирусные программы',
            'применяет HTTPS для передачи данных',
            'ограничивает доступ к базам данных',
            'организует мониторинг попыток несанкционированного доступа к данным',
            'использует системы резервного копирования, чтобы восстанавливать данные, если они были удалены по ошибке или при кибератаках',
            'регулярно обновляет технологии хранения и защиты данных с учетом последних разработок',
        ],
        subheading: 'Если происходит утечка персональных данных, то Администратор:',
        subBullets: [
            'в течение 24 часов уведомляет об этом Роскомнадзор',
            'в течение 72 часов проводит собственное расследование и информирую Роскомнадзор о его результатах',
        ],
    },
    {
        id: 'transfer',
        title: 'Кому передаются данные?',
        paragraphs: [
            'По общему правилу Администратор не передает персональные данные третьим лицам без согласия Пользователя.',
            'Передача персональных данных без согласия возможна, если:',
        ],
        bullets: [
            'этого требует закон',
            'это необходимо для предотвращения мошенничества',
        ],
        footerParagraphs: [
            'Администратор не отвечает за передачу персональных данных поисковым системам.',
        ],
    },
    {
        id: 'storage',
        title: 'Где хранятся данные?',
        paragraphs: [
            'Администратор хранит персональные данные на серверах, локализующихся на территории Российской Федерации.',
        ],
    },
    {
        id: 'updates',
        title: 'Как актуализируется Политика?',
        paragraphs: [
            'Отраслевые стандарты и бизнес-процессы непрерывно развиваются. Поэтому Администратор будет вносить изменения в Политику, если появятся новые требования закона или по собственной инициативе.',
            'Новая редакция Политики действует с даты ее опубликования на Сайте. Она всегда указывается внизу документа. Дальнейшее использование Сайта означает согласие Пользователя с новыми условиями Политики.',
            'Администратор рекомендует регулярно просматривать Политику и следить за обновлениями.',
        ],
    },
    {
        id: 'scope',
        title: 'На что распространяется Политика?',
        paragraphs: [
            'Сайт может содержать ссылки на внешние ресурсы — сайты третьих лиц.',
            'Политика не применяется к таким ресурсам. Администратор не контролирует и не несет ответственность за внешние ресурсы, на которые Пользователь может перейти по ссылкам, доступным на Сайте.',
        ],
    },
    {
        id: 'guarantees',
        title: 'Что не проверяет Администратор?',
        paragraphs: ['Администратор не может проверить, поэтому Пользователь гарантирует, что:'],
        bullets: [
            'обладает полной дееспособностью',
            'передал собственные достоверные персональные данные',
            'своевременно будет актуализировать данные',
        ],
    },
    {
        id: 'children',
        title: 'Обрабатываются ли данные детей?',
        paragraphs: [
            'Сайт не предназначен для обработки персональных данных несовершеннолетних. Если у Пользователя есть основания полагать, что ребенок предоставил свои персональные данные, нужно сообщить об этом Администратору.',
        ],
    },
    {
        id: 'disputes',
        title: 'Как будут решаться споры?',
        paragraphs: [
            'Для решения любых споров будут применяться законы Российской Федерации.',
            'Это правило действует независимо от гражданства, места жительства и местонахождения Пользователя при использовании Сайта.',
            'Судебные споры будут разрешаться по местонахождению Администратора.',
        ],
    },
    {
        id: 'contact',
        title: 'Как связаться с Администратором?',
        paragraphs: [
            'По любым вопросам в отношении обработки персональных данных Пользователь может обратиться к Администратору через форму на Сайте или по адресу электронной почты info@bypass-vpn.ru.',
            'В сообщении нужно указать контактный адрес электронной почты для обратной связи.',
            'Администратор ответит на обращение в течение 10 дней после его получения. При необходимости срок ответа может быть продлен на 5 рабочих дней после предварительного информирования Пользователя о причинах задержки ответа.',
        ],
    },
];

export const PRIVACY_VERSION_DATE = '10.06.2026';
